import { render, staticRenderFns } from "./incl-apotheke-bnums.vue?vue&type=template&id=1ed3b7c5"
import script from "./incl-apotheke-bnums.vue?vue&type=script&lang=js"
export * from "./incl-apotheke-bnums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports